<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>
        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1. ผู้รับผิดชอบโครงการ (Project Manager) (ภาคเอกชน)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
                theme="6"
                :disabled="teams.length >= 5"
                @onClick="addMoreTeam"
            >
              + เพิ่มข้อมูลผู้ประสานงาน
            </Button>
          </div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ชื่อผู้รับผิดชอบโครงการ
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p1_pm_name"
                  @onChange="setFormField('s2_p1_pm_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ตำเเหน่ง
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.positions"
                  item-text="name"
                  item-value="name"
                  :value="form.s2_p1_pm_position"
                  @onChange="setFormField('s2_p1_pm_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                เบอร์โทรศัพท์
              </div>
              <TextField
                  placeholder="09XXXXXXXX"
                  theme="3"
                  input-type="number"
                  :value="form.s2_p1_pm_phone"
                  @onChange="setFormField('s2_p1_pm_phone', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                E-mail
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p1_pm_email"
                  @onChange="setFormField('s2_p1_pm_email', $event)"
              ></TextField>
            </div>
          </div>

        </div>
      </div>
    </divcard>

    <!-- ข้อมูลคณะ -->
    <div class="px-5">
      <divcard
          v-for="(team, i) in teams"
          :key="i"
          class="mb-3"
      >
        <div class="black--text txt-m-head mb-3">1.{{ i + 1 }} ข้อมูลคณะ</div>
        <v-btn
            icon
            absolute
            top
            right
            style="z-index: 99"
            @click="delTeam(i)"
        >
          <Iconify
              class="font-18"
              style="color: #b1b1b1"
              icon="mdi:delete"
          />
        </v-btn>
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ชื่อผู้ประสานงานโครงการ</div>
            <TextField
                theme="3"
                :value="team.s2_p1_name"
                @onChange="setTeamField('s2_p1_name', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">ตำเเหน่ง</div>
            <AutoBox
                theme="3"
                :items="masterData.positions"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_position"
                @onChange="setTeamField('s2_p1_position', i, $event)"
            ></AutoBox>
          </div>
        </div>

        <!-- Form 1 #line3 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
            <TextField
              placeholder="09XXXXXXXX"
                theme="3"
                input-type="number"
                :value="team.s2_p1_phone"
                @onChange="setTeamField('s2_p1_phone', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">E-mail</div>
            <TextField
                theme="3"
                :value="team.s2_p1_email"
                @onChange="setTeamField('s2_p1_email', i, $event)"
            ></TextField>
          </div>
        </div>

      </divcard>

    </div>

    <!--  Activity 1 Form 2-6 [SI,PF] , Activity 2 Form 2-5 [SI,PF]  -->
    <template>
      <divcard v-if="activity && activity !== '3'">
        <div>
          <div class="txt-head black--text mb-3">
            2. ขั้นตอนและขอบเขตการดำเนินกิจกรรม
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
                <Wysiwyg
                    theme="3"
                    :value="form.s2_act_scope"
                    @onChange="setFormField('s2_act_scope', $event)"
                ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ขั้นตอนและขอบเขตการดำเนินกิจกรรม -->
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            {{ activity && activity !== '3' ? '3' : '2' }}. หลักการและเหตุผล
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              (ระบุที่มาและความสำคัญของการดำเนินโครงการแสดงรายละเอียดข้อมูลของปัญหาที่ผู้ประกอบการต้องการพัฒนา และปรับปรุงประสิทธิภาพ
              และผลลัพธ์ที่คาดว่าจะได้รับจากการนําเทคโนโลยี องค์ความรู้ และความช่วยเหลือของคณะผู้เชี่ยวชาญเข้าไปแก้ไขปัญหาและพัฒนากิจการเพิ่มประสิทธิภาพของกิจการของ
              ผู้ประกอบการ ชี้แจง รายละเอียดโดยย่อ)
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
                <Wysiwyg
                    theme="3"
                    :value="form.s2_principle"
                    @onChange="setFormField('s2_principle', $event)"
                ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- หลักการและเหตุผล -->
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            {{ activity && activity !== '3' ? '4' : '3' }}. วัตถุประสงค์
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              (ระบุข้อมูลที่ใช้วัดผลความสำเร็จเมื่อเสร็จโครงการ แสดงทั้งในรูปแบบของเชิงปริมาณและคุณภาพให้มีความสอดคล้องกับ วัตถุประสงค์ของโครงการ)
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
                <TextArea
                    theme="3"
                    :value="form.s2_objective"
                    @onChange="setFormField('s2_objective', $event)"
                ></TextArea>
            </div>
          </div>
        </div>
      </divcard><!-- วัตถุประสงค์ -->
      <divcard v-if="activity && activity === '1'">
        <div>
          <div class="txt-head black--text mb-3">
            5. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
                <Wysiwyg
                    theme="3"
                    :value="form.s2_focus_industry"
                    @onChange="setFormField('s2_focus_industry', $event)"
                ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- act 1 f 5 กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย -->
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            {{ activity && activity === '1' ? '6' : activity === '2' ? '5' : '4' }}. เป้าหมาย
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
                <Wysiwyg
                    theme="3"
                    :value="form.s2_target"
                    @onChange="setFormField('s2_target', $event)"
                ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!--act1 f6, act2 f5  เป้าหมาย -->
    </template>

    <!--  Activity 1 Form 7 [SI] , Activity 3 Form5 [SI] [PF]  -->
    <template v-if="activity && (activity === '1' && !isFinal) || (activity === '3')">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            {{ activity === '1' ? '7' : '5' }}. ผลการดำเนินงานที่ผ่านมา
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
                <Wysiwyg
                    theme="3"
                    :value="form.s2_past_work"
                    @onChange="setFormField('s2_past_work', $event)"
                ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ผลการดำเนินงานที่ผ่านมา -->
    </template>

    <!--  Activity 3, Form 6, [SI] [PF]  -->
    <template v-if="activity && activity === '3'">
      <divcard>
        <div class="card-part pt-0">
          <div>
            <div class="txt-head black--text mb-3">
              6. แนวคิดและภาพรวมการจัดกิจกรรม
            </div>

            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  แนวคิดและรูปแบบการจัดกิจกรรม
                </div>
                <Wysiwyg
                    theme="3"
                    :value="form.s2_act_concept"
                    @onChange="setFormField('s2_act_concept', $event)"
                ></Wysiwyg>
              </div>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมในการจัดงานของอุทยานวิทยาศาสตร์
                <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                  (ประสบการณ์ในการดำเนินงานที่สอดคล้องกับกิจกรรมที่ผ่านมา ความเชี่ยวชาญในเนื้องาน )
                </div>
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_ready"
                  @onChange="setFormField('s2_ready', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การกำหนดคุณสมบัติของผู้เข้าร่วมแข่งขัน
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_qualify"
                  @onChange="setFormField('s2_qualify', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การกำหนดเกณฑ์ที่ใช้ในการตัดสินและคณะกรรมการในการตัดสิน
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_criteria"
                  @onChange="setFormField('s2_criteria', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนวทางการเชื่อมโยงผลักดันผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
                <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                  (ที่สามารถเห็นผลได้ชัดเจนในอนาคต)
                </div>
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_guideline"
                  @onChange="setFormField('s2_guideline', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- แนวคิดและภาพรวมการจัดกิจกรรม Group -->
    </template>

    <!--  Activity 3, Form 7, [SI] [PF]  -->
    <template v-if="activity && activity === '3'">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            7. ขั้นตอนและขอบเขตการดำเนินกิจกรรม
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_act_scope"
                  @onChange="setFormField('s2_act_scope', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ขั้นตอนและขอบเขตการดำเนินกิจกรรม -->
    </template>

    <!--  Activity 1 Form 8 [SI] Form 7 [PF]  -->
    <template v-if="activity && activity === '1'">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            {{ isFinal ? '7' : '8' }}. แนวคิดและภาพรวมการจัดกิจกรรม
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
                <Wysiwyg
                    theme="3"
                    :value="form.s2_act_idea"
                    @onChange="setFormField('s2_act_idea', $event)"
                ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- แนวคิดและภาพรวมการจัดกิจกรรม Single -->
    </template>

    <!--  Activity 1 Form 9 [SI]  -->
    <template v-if="activity && activity === '1' && !isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            9. ขั้นตอนการดำเนินกิจกรรม
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_act_process"
                  @onChange="setFormField('s2_act_process', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ขั้นตอนการดำเนินกิจกรรม Single -->
    </template>

    <!--  Activity 1 Form 10 [SI] Form 8 [PF] -->
    <template v-if="activity && activity === '1'">
      <divcard>
        <div class="card-part pt-0">
          <div>
            <div class="txt-head black--text mb-3">
              {{isFinal ? '8': '10'}} . ขั้นตอนการดำเนินงาน/กิจกรรมหลัก
              <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                (อธิบายอย่างละเอียด)
              </div>
            </div>

            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  วิธีหาลูกค้าที่มีศักยภาพ การเจาะกลุ่มเป้าหมาย และตัวอย่างผู้ประกอบการที่สนใจเข้าร่วมโครงการ
                </div>
                <Wysiwyg
                    theme="3"
                    :value="form.s2_finding"
                    @onChange="setFormField('s2_finding', $event)"
                ></Wysiwyg>
              </div>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กระบวนการและเกณฑ์การคัดเลือกผู้ประกอบการ
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_ent_select"
                  @onChange="setFormField('s2_ent_select', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การบริหารจัดการและกระบวนการดำเนินงานของหน่วยบ่มเพาะ
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การบ่มเพาะผู้ประกอบการรายเดิม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_original_ent"
                        @onChange="
                      setFormField('s2_original_ent', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การบ่มเพาะผู้ประกอบการรายใหม่
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_new_ent"
                        @onChange="
                      setFormField('s2_new_ent', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ศักยภาพ ความพร้อมในการให้บริการของศูนย์บ่มเพาะและอุทยานวิทยาศาสตร์ภูมิภาค
            </div>
            <ul class="pl-16">
              <li>
                <div>
                  <div class="black--text mb-3">
                    บุคลากร พี่เลี้ยง
                  </div>
                  <Wysiwyg
                      theme="3"
                      :value="form.s2_nanny"
                      @onChange="
                        setFormField('s2_nanny', $event)
                      "
                  ></Wysiwyg>
                </div>
              </li>
              <li>
                <div>
                  <div class="black--text mb-3">
                    ผู้เชี่ยวชาญที่ช่วยสนับสนุนความรู้ในด้านต่างๆ
                  </div>
                  <Wysiwyg
                      theme="3"
                      :value="form.s2_expert"
                      @onChange="
                        setFormField('s2_expert', $event)
                      "
                  ></Wysiwyg>
                </div>
              </li>
              <li>
                <div>
                  <div class="black--text mb-3">
                    เครือข่ายทางธุรกิจเทคโนโลยีที่เกี่ยวข้อง
                  </div>
                  <Wysiwyg
                      theme="3"
                      :value="form.s2_network"
                      @onChange="
                        setFormField('s2_network', $event)
                      "
                  ></Wysiwyg>
                </div>
              </li>
              <li>
                <div>
                  <div class="black--text mb-3">
                    โครงสร้างพื้นฐาน พื้นที่ให้เช่า และสิ่งอำนวยความสะดวกต่างๆ
                  </div>
                  <Wysiwyg
                      theme="3"
                      :value="form.s2_facility"
                      @onChange="
                        setFormField('s2_facility', $event)
                      "
                  ></Wysiwyg>
                </div>
              </li>
              <li>
                <div>
                  <div class="black--text mb-3">
                    บริการอื่นๆที่เกี่ยวข้อง เช่น ด้านการเงิน การบริหารจัดการทรัพย์สินทางปัญญา เป็นต้น
                  </div>
                  <Wysiwyg
                      theme="3"
                      :value="form.s2_service"
                      @onChange="
                        setFormField('s2_service', $event)
                      "
                  ></Wysiwyg>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรม เส้นทางสู่นวัตวณิชย์ Research to Market (R2M)
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_operation"
                        @onChange="
                        setFormField('s2_operation', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_main_ads"
                        @onChange="
                        setFormField('s2_main_ads', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การต่อยอดพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_main_continue"
                        @onChange="
                        setFormField('s2_main_continue', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_project_evaluate"
                  @onChange="setFormField('s2_project_evaluate', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>

      </divcard><!--ขั้นตอนการดำเนินงาน/กิจกรรมหลัก -->
    </template>

    <!--  Activity 1 Form 9 [PF] -->
    <template v-if="activity && activity === '1' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            9. ผลการดำเนินงาน
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              (อธิบายอย่างละเอียด)
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_performance"
                  @onChange="setFormField('s2_performance', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ผลการดำเนินงาน -->
    </template>

    <!--  Activity 2 Form 6 [SI] [PF]  -->
    <template v-if="activity && activity === '2'">
      <divcard>
        <div class="card-part pt-0">
          <div>
            <div class="txt-head black--text mb-3">
              6. แนวคิดและภาพรวมการจัดกิจกรรม
            </div>

            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  แนวคิดและรูปแบบการจัดกิจกรรม
                </div>
                <Wysiwyg
                    theme="3"
                    :value="form.s2_act_concept"
                    @onChange="setFormField('s2_act_concept', $event)"
                ></Wysiwyg>
              </div>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมในการจัดงานของอุทยานวิทยาศาสตร์
                <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                  (ประสบการณ์ในการดำเนินงานที่สอดคล้องกับกิจกรรมที่ผ่านมา ความเชี่ยวชาญในเนื้องาน )
                </div>
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_ready"
                  @onChange="setFormField('s2_ready', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การกำหนดคุณสมบัติของผู้เข้าร่วมแข่งขัน
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_qualify"
                  @onChange="setFormField('s2_qualify', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การกำหนดเกณฑ์ที่ใช้ในการตัดสินและคณะกรรมการในการตัดสิน
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_criteria"
                  @onChange="setFormField('s2_criteria', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนวทางการเชื่อมโยงผลักดันผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
                <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                  (ที่สามารถเห็นผลได้ชัดเจนในอนาคต)
                </div>
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_guideline"
                  @onChange="setFormField('s2_guideline', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- แนวคิดและภาพรวมการจัดกิจกรรม Group -->
    </template>

    <!--  Activity 2 Form 7 [SI] [PF] , Activirt 3 Form 8 [PF]  -->
    <template v-if="activity && activity === '2' || (activity === '3' && isFinal)">
      <divcard>
        <div class="card-part pt-0">
          <div>
            <div class="txt-head black--text mb-3">
              {{ activity === '2' ? '7' : '8' }}. ขั้นตอนการดำเนินกิจกรรม
            </div>

            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
                </div>
                <Wysiwyg
                    theme="3"
                    :value="form.s2_ads"
                    @onChange="setFormField('s2_ads', $event)"
                ></Wysiwyg>
              </div>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การคัดเลือกผู้เข้าร่วมโครงการและวิธีในการคัดเลือกสิ่งประดิษฐ์หรือนวัตกรรมที่มีศักยภาพในการต่อยอดสู่เชิงพาณิชย์
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_select"
                  @onChange="setFormField('s2_select', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การดำเนินการเตรียมความพร้อมให้กับผู้ที่เข้าร่วมโครงการ
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_action"
                  @onChange="setFormField('s2_action', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part" v-if=" (activity === '2' && !isFinal) || activity === '3' ">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับมหาวิทยาลัย
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_act_uni"
                  @onChange="setFormField('s2_act_uni', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part" v-if=" (activity === '2' && !isFinal) || activity === '3' ">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับภูมิภาค
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_act_region"
                  @onChange="setFormField('s2_act_region', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับประเทศ
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_act_country"
                  @onChange="setFormField('s2_act_country', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดแนวทางการต่อยอดเพื่อพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_continue"
                  @onChange="setFormField('s2_continue', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ 
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_p8_project_evaluate"
                  @onChange="setFormField('s2_p8_project_evaluate', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ขั้นตอนการดำเนินกิจกรรม Group -->
    </template>

    <!--  Activity 2 Form 8 [PF] ขั้นตอนการดำเนินงาน/กิจกรรมหลัก -->
    <template v-if="activity && activity === '2' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            8. ขั้นตอนการดำเนินงาน/กิจกรรมหลัก
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              (อธิบายอย่างละเอียด)
            </div>
          </div>

          <div class="card-part">
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การจัดกิจกรรม RSP New Release
                </div>
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-3">
                        การดำเนินงาน
                      </div>
                      <Wysiwyg
                          theme="3"
                          :value="form.s2_operation"
                          @onChange="
                      setFormField('s2_operation', $event)
                    "
                      ></Wysiwyg>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-3">
                        การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
                      </div>
                      <Wysiwyg
                          theme="3"
                          :value="form.s2_ads"
                          @onChange="
                      setFormField('s2_ads', $event)
                    "
                      ></Wysiwyg>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-3">
                        การต่อยอดพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
                      </div>
                      <Wysiwyg
                          theme="3"
                          :value="form.s2_continue"
                          @onChange="
                      setFormField('s2_continue', $event)
                    "
                      ></Wysiwyg>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </divcard><!-- ขั้นตอนการดำเนินงาน/กิจกรรมหลัก -->
    </template>


    <!-- Activity 2 Form 9 [PF]  ผลการดำเนินงาน -->
    <template v-if="activity && activity === '2' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
              9. ผลการดำเนินงาน
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              (อธิบายอย่างละเอียด)
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_performance"
                  @onChange="setFormField('s2_performance', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ผลการดำเนินงาน -->
    </template>
    
    <!--  Activity 3, Form 8 [SI] Form 9 [PF] -->
    <template v-if="activity && activity === '3'">
      <divcard>     
            <div class="txt-head black--text mb-3">
              {{ !isFinal ? '8' : '9' }}. ขั้นตอนการดำเนินงาน/กิจกรรมหลัก
              <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                (อธิบายอย่างละเอียด)
              </div>
            </div>
          <div class="card-part pt-0" v-if="!isFinal">
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  วิธีหาลูกค้าที่มีศักยภาพ การเจาะกลุ่มเป้าหมาย และตัวอย่างผู้ประกอบการที่สนใจเข้าร่วมโครงการ
                </div>
                <Wysiwyg
                    theme="3"
                    :value="form.s2_finding"
                    @onChange="setFormField('s2_finding', $event)"
                ></Wysiwyg>
              </div>
            </div>
          </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กระบวนการและเกณฑ์การคัดเลือกผู้ประกอบการ
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_ent_select"
                  @onChange="setFormField('s2_ent_select', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การบริหารจัดการและกระบวนการดำเนินงานของหน่วยบ่มเพาะ
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การบ่มเพาะผู้ประกอบการรายเดิม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_original_ent"
                        @onChange="
                      setFormField('s2_original_ent', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การบ่มเพาะผู้ประกอบการรายใหม่
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_new_ent"
                        @onChange="
                      setFormField('s2_new_ent', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ศักยภาพ ความพร้อมในการให้บริการของศูนย์บ่มเพาะและอุทยานวิทยาศาสตร์ภูมิภาค
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      บุคลากร พี่เลี้ยง
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_nanny"
                        @onChange="
                        setFormField('s2_nanny', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ผู้เชี่ยวชาญที่ช่วยสนับสนุนความรู้ในด้านต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_expert"
                        @onChange="
                        setFormField('s2_expert', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      เครือข่ายทางธุรกิจเทคโนโลยีที่เกี่ยวข้อง
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_network"
                        @onChange="
                        setFormField('s2_network', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      โครงสร้างพื้นฐาน พื้นที่ให้เช่า และสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_facility"
                        @onChange="
                        setFormField('s2_facility', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      บริการอื่นๆที่เกี่ยวข้อง เช่น ด้านการเงิน การบริหารจัดการทรัพย์สินทางปัญญา เป็นต้น
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_service"
                        @onChange="
                        setFormField('s2_service', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-part" v-if="isFinal">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรม เส้นทางสู่นวัตวณิชย์ Research to Market (R2M)
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_operation"
                        @onChange="
                        setFormField('s2_operation', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_main_ads"
                        @onChange="
                        setFormField('s2_main_ads', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3">
                      การต่อยอดพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.s2_main_continue"
                        @onChange="
                        setFormField('s2_main_continue', $event)
                      "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_p9_project_evaluate"
                  @onChange="setFormField('s2_p9_project_evaluate', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>

      </divcard><!--ขั้นตอนการดำเนินงาน/กิจกรรมหลัก -->
    </template>

    <!--  Activity 3 Form 10 [PF] -->
    <template v-if="activity && activity === '3' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            9. ผลการดำเนินงาน
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              (อธิบายอย่างละเอียด)
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_performance"
                  @onChange="setFormField('s2_performance', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ผลการดำเนินงาน -->
    </template>

     <!--  Activity 2 Form 8 [PF]  ขั้นตอนการดำเนินกิจกรรม RSP New Release -->
     <template v-if="activity && activity === '2' && !isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            8. ขั้นตอนการดำเนินกิจกรรม RSP New Release
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_rsp_procedure"
                  @onChange="setFormField('s2_rsp_procedure', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ขั้นตอนการดำเนินกิจกรรม RSP New Release -->
    </template>

    <!--  Activity 2 Form 9 [SI] -->
    <template v-if="activity && activity === '2' && !isFinal">
      <divcard>
        <div class="card-part pt-0">
          <div>
            <div class="txt-head black--text mb-3">
              9. กระบวนการดำเนินกิจกรรมและเกณฑ์การคัดเลือกผู้ประกอบการ
            </div>

            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การประชาสัมพันธ์ กิจกรรม RSP New Release
                </div>
                <Wysiwyg
                    theme="3"
                    :value="form.s2_rsp_ads"
                    @onChange="setFormField('s2_rsp_ads', $event)"
                ></Wysiwyg>
              </div>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การคัดเลือกของผู้ประกอบการ (ระดับมหาวิทยาลัย)
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_select_uni"
                  @onChange="setFormField('s2_select_uni', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กิจกรรมการนาเสนอโมเดลธุรกิจนวัตกรรม (Pitching Business Innovation Model) และการประกวดเฟ้นหา RSP First
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_model"
                  @onChange="setFormField('s2_model', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>

      </divcard><!-- กระบวนการดำเนินกิจกรรมและเกณฑ์การคัดเลือกผู้ประกอบการ Group -->
    </template>

    <!--  Activity 2, Form 10, [PF] -->
    <template v-if="activity && activity === '2' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            10. ผลการจัดกิจกรรมเส้นทางสู่นวัตวณิชย์
          </div>

          <div class="card-part">
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  กิจกรรมระดับประเทศ
                </div>
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-3">
                        แผนการดำเนินงานในการจัดการแข่งขัน
                        <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                          (จัดการแข่งขัน  จัดเมื่อไหร่  จัดที่ไหน ใครเป็นกรรมการ ผลการแข่งขัน)
                        </div>
                      </div>
                      <Wysiwyg
                          theme="3"
                          :value="form.s2_action_plan"
                          @onChange="
                      setFormField('s2_action_plan', $event)
                    "
                      ></Wysiwyg>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </divcard><!-- ผลการจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ -->
    </template>

     <!--  Activity 2 Form 11 [PF]  ขั้นตอนการดำเนินกิจกรรม RSP New Release -->
     <template v-if="activity && activity === '2' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            11. ขั้นตอนการดำเนินกิจกรรม RSP New Release
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_rsp_procedure"
                  @onChange="setFormField('s2_rsp_procedure', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- ขั้นตอนการดำเนินกิจกรรม RSP New Release Single -->
    </template>

    <!--  Activity 2, Form 12, [PF] -->
    <template v-if="activity && activity === '2' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            12. กระบวนการดำเนินกิจกรรมและเกณฑ์การคัดเลือกผู้ประกอบการ
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การประชาสัมพันธ์ กิจกรรม RSP New Release
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_rsp_ads"
                  @onChange="setFormField('s2_rsp_ads', $event)"
              ></Wysiwyg>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การคัดเลือกของผู้ประกอบการ (ระดับมหาวิทยาลัย) ใช้เกณฑ์ใดคัดเลือก
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_select_uni"
                  @onChange="setFormField('s2_select_uni', $event)"
              ></Wysiwyg>
            </div>
          </div>

          <div class="card-part">
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  กิจกรรมการประกวดเฟ้นหา RSP First ในระดับประเทศ
                </div>
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-3">
                        แผนการดำเนินงานในการจัดการแข่งขัน
                        <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                          (จัดการแข่งขัน  จัดเมื่อไหร่  จัดที่ไหน ใครเป็นกรรมการ ผลการแข่งขัน)
                        </div>
                      </div>
                      <Wysiwyg
                          theme="3"
                          :value="form.s2_competition_plan"
                          @onChange="
                      setFormField('s2_competition_plan', $event)
                    "
                      ></Wysiwyg>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-3">
                        แผนการจัดกิจกรรมส่งเสริมการสร้างเครือข่ายผู้ประกอบการ
                        <div class="theme-color-seven txt-normal" style="text-indent: 16px">
                          (จัดให้มีกิจกรรมอะไร ที่ไหน การเตรียมการของแต่ละมหาวิทยาลัยและผู้ประกอบการ ใครเข้าร่วมงานบ้าง)
                        </div>
                      </div>
                      <Wysiwyg
                          theme="3"
                          :value="form.s2_competition_network"
                          @onChange="
                      setFormField('s2_competition_network', $event)
                    "
                      ></Wysiwyg>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </divcard><!-- กระบวนการดำเนินกิจกรรมและเกณฑ์การคัดเลือกผู้ประกอบการ Group -->
    </template>

    <!--  Activity 2 Form 10 [SI] Form 13 [PF] -->
    <template v-if="activity && activity === '2' ">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            {{ isFinal ? '13' : '10' }}. การติดตามและประเมินผล
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_evaluate"
                  @onChange="setFormField('s2_evaluate', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard><!-- การติดตามและประเมินผล Single -->
    </template>

    <!--  Activity 2, Form 14, [PF] -->
    <!-- <template v-if="activity && activity === '2' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            14. ผลการดำเนินงาน
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_performance2"
                  @onChange="setFormField('s2_performance2', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard>ผลการดำเนินงาน 
    </template> -->

    <!--  Activity 2, Form 14, [PF] -->
    <template v-if="activity && activity === '2' && isFinal">
      <divcard>
        <div>
          <div class="txt-head black--text mb-3">
            14. ประโยชน์ที่ได้รับจากการดำเนินงาน
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <Wysiwyg
                  theme="3"
                  :value="form.s2_benefit"
                  @onChange="setFormField('s2_benefit', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </divcard> <!--ประโยชน์ที่ได้รับจากการดำเนินงาน-->
    </template>


  </div>
</template>

<script>
import TextField from "../../../../components/input/TextField"
import TextArea from "../../../../components/input/TextArea"
import SwitchInset from "../../../../components/input/SwitchInset"
import AutoBox from "../../../../components/input/AutoBox"
import { eventBus, formatNumber } from "../../../../plugins/global-funcs"
import { mapState } from "vuex"
import Button from "@/components/input/Button.vue";
import Wysiwyg from "@/components/input/Wysiwyg.vue";
import {is} from "date-fns/locale";

export default {
  name: "CFormProject_STI",
  components: {
    Wysiwyg,
    Button,
    TextField,
    TextArea,
    SwitchInset,
    AutoBox
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      formatNumber,
      form: {},
      activity: null,
      teams: []
    }
  },
  computed: {
    is() {
      return is
    },
    ...mapState({
      ProjectForm: state => state.CForm.ProjectForm,
      GeneralForm: state => state.CForm.GeneralForm
    }),
    isFinal () {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  created () {
    if (this.isSameId && !this.masterData.form_c) {
      this.form = { ...this.ProjectForm, project_teams: undefined }
      this.teams = this.ProjectForm.project_teams || [];
    }
    if (this.masterData.form_c) {
      this.form = this.masterData.form_c.project_section
      this.teams = this.masterData.form_c.project_teams || [];
      this.activity = this.masterData.form_c.project_section_general_info.activity || null
      console.log('teams', this.teams)
    }
    eventBus.$on('cFormProject', () => {
      eventBus.$emit("cFormProjectSend", { ...this.form, project_teams: this.teams });
    })

  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    setTeamField(field, i, val) {
      this.teams[i][field] = val;
      this.$forceUpdate();
    },
    addMoreTeam () {
      this.teams.push({})
    },
    delTeam (index) {
      this.teams.splice(index, 1)
    }
  }
}
</script>

<style scoped>

</style>